// extracted by mini-css-extract-plugin
export default {"tabtitle":"tabtitle_VwBDm","count":"count_Q0_pm"};